import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  host: {
    class: 'app-accordion',
    '[class.app-accordion_opened]': 'opened',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('content', [
      transition(':enter', [style({ height: 0 }), animate('300ms', style({ height: '*' }))]),
      transition(':leave', [style({ height: '*' }), animate('300ms', style({ height: 0 }))]),
    ]),
  ],
})
export class AccordionComponent {
  @Input() name!: string;
  @Input() complete: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;

  @Input()
  get opened(): boolean {
    return this._isOpened;
  }

  set opened(value: boolean) {
    this._isOpened = value;
  }

  private _isOpened: boolean = false;

  toggle() {
    if (this.disabled) return;
    this._isOpened = !this._isOpened;
  }
}
